import { useEffect, useState } from "react";

import * as styles  from "./styles.module.scss";

export const TrackProgress = () => {
    const [duration, setDuration] = useState(null);
    const [progress, setProgress] = useState(null);

    useEffect(() => {
        const handleLoaded = ({ duration }) => {
            setProgress(0);
            setDuration(duration);
        };

        const handleProgress = ({ currentTime, duration }) => {
            setProgress(currentTime);
            setDuration(duration);
        };

        window.audioplayer.addEventListener("load", handleLoaded);
        window.audioplayer.addEventListener("progress", handleProgress);

        return () => {
            window.audioplayer.removeEventListener("load", handleLoaded);
            window.audioplayer.removeEventListener("progress", handleProgress);
        };
    }, []);
    
    const progressWidth = getPercentage(progress, duration);

    return (
        <div className={styles.progress}>
            <div className={styles.bar}>
                <div
                    className={styles.fill}
                    style={{ width: `${progressWidth}%` }}
                />
            </div>
            <div className={styles.time}>
                <span className={styles.current}>
                    {formatTime(progress || 0)}
                </span>
                <span className={styles.total}>
                    {duration !== null && formatTime(duration || 0)}
                </span>
            </div>
        </div>
    );
};

const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);

    return `${mins}:${secs.toString().padStart(2, "0")}`;
};

const getPercentage = (current, total) => {
    const currentNum = Number(current);
    const totalNum = Number(total);
    
    if (!Number.isFinite(currentNum) || !Number.isFinite(totalNum) || totalNum <= 0) {
        return 0;
    }

    return Math.min(100, Math.max(0, (currentNum / totalNum) * 100));
};
